import { Link } from "react-router-dom";

import List from "@vapor/react-material/List";
import ListItem from "@vapor/react-material/ListItem";
import ListItemIcon from "@vapor/react-material/ListItemIcon";
import ListItemText from "@vapor/react-material/ListItemText";
import ArticleIcon from "@mui/icons-material/Article";

export const NavContent = ({ basePath }) => (
  <List>
    <ListItem button component={Link} to={basePath}>
      <ListItemIcon>
        <ArticleIcon />
      </ListItemIcon>
      <ListItemText primary={"Examples"} />
    </ListItem>
  </List>
);
